import { UtilS } from '@modules/Util/S/Function/module/UtilS';

export class Prof {
  private marks = new Map<string, number>();
  private measures: Array<{ name: string; ms: number }> = [];
  private sections: Record<string, number> = {};
  private segStats: Record<string, { count: number; totalMs: number }> = {};

  private isProductionOrTest(): boolean {
    try {
      // Check if in Jest test environment
      if (
        typeof jest !== 'undefined' ||
        (typeof process !== 'undefined' && process.env?.NODE_ENV === 'test') ||
        (typeof process !== 'undefined' && process.env?.JEST_WORKER_ID !== undefined)
      ) {
        return true;
      }

      // Check production environment
      return UtilS.isProd();
    } catch {
      // Fallback for environments where UtilS is not available
      if (typeof process !== 'undefined' && process.env) {
        return process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test';
      }
      return false;
    }
  }

  mark(name: string) {
    if (this.isProductionOrTest()) return;
    this.marks.set(name, performance.now());
  }

  end(name: string) {
    if (this.isProductionOrTest()) return 0;
    const t0 = this.marks.get(name);
    if (t0 != null) {
      const ms = performance.now() - t0;
      this.measures.push({ name, ms });
      this.marks.delete(name);
      return ms;
    }
    return 0;
  }

  addSection(name: string, ms: number) {
    this.sections[name] = (this.sections[name] ?? 0) + ms;
  }

  addSeg(type: string, ms: number) {
    const s = (this.segStats[type] ??= { count: 0, totalMs: 0 });
    s.count += 1;
    s.totalMs += ms;
  }

  report(prefix = '[PROFILE]') {
    if (this.isProductionOrTest()) return;
    const total = this.measures.reduce((a, b) => a + b.ms, 0);
    console.log(`${prefix} Total measured ~ ${total.toFixed(2)} ms`);
    // 주요 마일스톤
    const byName = Object.fromEntries(this.measures.map((m) => [m.name, m.ms]));
    console.table(byName);

    // 섹션 합계
    console.log(`${prefix} Sections (aggregated)`);
    console.table(
      Object.entries(this.sections)
        .sort((a, b) => b[1] - a[1])
        .map(([k, v]) => ({ section: k, ms: +v.toFixed(2) })),
    );

    // 세그먼트 통계
    console.log(`${prefix} Segment types`);
    console.table(
      Object.entries(this.segStats)
        .sort((a, b) => b[1].totalMs - a[1].totalMs)
        .map(([type, s]) => ({
          type,
          count: s.count,
          totalMs: +s.totalMs.toFixed(2),
          avgMs: +(s.totalMs / Math.max(1, s.count)).toFixed(4),
        })),
    );
  }
}
